/**
 * Convert a Monaco editor symbol tag to an LSP symbol tag.
 *
 * @param symbolTag
 *   The Monaco symbol tag to convert.
 * @returns
 *   The symbol tag as an LSP symbol tag.
 */
export function fromSymbolTag(symbolTag) {
    return symbolTag;
}
/**
 * Convert an LSP symbol tag to a Monaco editor symbol tag.
 *
 * @param symbolTag
 *   The LSP symbol tag to convert.
 * @returns
 *   The symbol tag as Monaco editor symbol tag.
 */
export function toSymbolTag(symbolTag) {
    return symbolTag;
}
//# sourceMappingURL=symbolTag.js.map